import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductUsage } from "./UseProductUsage";

export default function PUsageAutoComplete(props) {
  const { getAllUsageList } = UseProductUsage();
  const [productUsageRes, setProductUsageRes] = React.useState();
  const [selectedUsage, setSelectedUsage] = React.useState();

  useEffect(() => {
    getAllUsageList((tastes) => {
      setProductUsageRes(tastes);
    });
  }, []);

  useEffect(() => {
    if (productUsageRes && props.selectedUsageID) {
      setSelectedUsage(
        productUsageRes.appropriate.find((m) => m.id == props.selectedUsageID)
      );
    }
  }, [productUsageRes, props.selectedUsageID]);

  useEffect(() => {
    if (selectedUsage) {
      props.setter({
        ...props.lvl3State,
        appropriateID: selectedUsage.id,
      });
    }
  }, [selectedUsage]);

  return productUsageRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedUsage ? selectedUsage : ""}
        options={productUsageRes.appropriate ? productUsageRes.appropriate : []}
        getOptionLabel={(tastes) => (tastes.title ? tastes.title : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="مورد مصرف" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.title ? option.title : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedUsage(newValue);
          } else {
            setSelectedUsage();
            props.setter({
              ...props.lvl3State,
              appropriateID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllUsageList((tastes) => {
            setProductUsageRes(tastes);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/appropriate" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
